import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export default function Categories() {
  const [cats, setCats] = useState([]);
  const { t, tCategory } = useLang();
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);
  const products = cats.filter((c) => c.kind === "product" || c.kind === "both");
  const services = cats.filter((c) => c.kind === "service" || c.kind === "both");

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12" data-testid="categories-page">
      <h1 className="heading font-extrabold text-4xl mb-2">{t("categories.title")}</h1>
      <p className="text-[#4B5563] mb-10">{t("categories.subtitle")}</p>

      <section className="mb-12">
        <h2 className="heading font-extrabold text-2xl mb-4">{t("header.products")}</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="cats-products">
          {products.map((c) => (
            <Link key={c.id} to={`/recherche?category_id=${c.id}&kind=product`} className="bg-white border border-[#1A3322]/10 hover:border-[#1A3322] p-5 rounded-lg" data-testid={`cat-${c.slug}`}>
              <p className="font-semibold">{tCategory(c)}</p>
            </Link>
          ))}
        </div>
      </section>

      <section>
        <h2 className="heading font-extrabold text-2xl mb-4">{t("header.services")}</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="cats-services">
          {services.map((c) => (
            <Link key={c.id} to={`/recherche?category_id=${c.id}&kind=service`} className="bg-white border border-[#1A3322]/10 hover:border-[#1A3322] p-5 rounded-lg">
              <p className="font-semibold">{tCategory(c)}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
